const missionCategories = {
    0: null,
    1: "Factory visit",
    2: "Site visit",
    3: "Store check",
    4: "Other"
};

export default missionCategories;
